<template>
  <div class="data-list-container">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-full md:w-5/12 lg:w-1/3 xl:w-1/3 p-4">
        <vs-card title="Client" class="cstm_vx_card mb-4">
          <div slot="header" class="flex flex-wrap justify-between items-center">
            <h4>Student Info</h4>
          </div>
          <div style="word-break: break-all;">
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-align="center"
                vs-justify="center"
                vs-w="12"
              >
              <profile-image :image="clientDetails.basic_details.picture" @changingImage="ImageChanged"/>
              </vs-col>
              <vs-col
                vs-w="12"
              >
                <h3 style="font-weight:bold;" class="text-primary text-center mt-2">{{ clientDetails.basic_details.first_name }} {{ clientDetails.basic_details.last_name }}</h3>
                <vs-row vs-justify="center" class="mt-2 flex-nowrap">
                  <vs-icon icon-pack="feather" color="primary" icon="icon-mail" class="account-icon" />
                  <b style="font-weight: 600;" class="pl-2">{{ clientDetails.basic_details.email }}</b>
                </vs-row>
                <vs-row vs-justify="center" class="mt-2 flex-nowrap">
                  <vs-icon icon-pack="feather" color="primary" icon="icon-map-pin" class="account-icon" />
                    <b style="font-weight: 600;" class="pl-2" v-if="clientDetails.basic_details.address.city !=='' ||  clientDetails.basic_details.address.state !=='' || clientDetails.basic_details.address.platform_customer_countries_id !=='' ">
                      <span v-if="clientDetails.basic_details.address.city!==''" style="word-break:break-word;">
                        {{ clientDetails.basic_details.address.city }},
                      </span>
                      <span v-if="clientDetails.basic_details.address.state !==''" style="word-break:break-word;">
                        {{ clientDetails.basic_details.address.state }},
                      </span>
                      <span v-if="clientDetails.basic_details.address.platform_customer_countries_id !==''" style="word-break:break-word;">
                        {{ getcountry(clientDetails.basic_details.address.platform_customer_countries_id) }}
                      </span>
                    </b>
                    <b style="font-weight: 600;" class="pl-2" v-else>
                      Unavailable
                    </b>
                </vs-row>
                <vs-row vs-justify="center" class="mt-2" v-if="clientDetails.social_media!=null">
                  <a :href="clientDetails.social_media.facebook" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-facebook" class="mr-3 account-icon"/>
                  </a>
                  <a :href="clientDetails.social_media.twitter" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-twitter" class="mr-3 account-icon"/>
                  </a>
                  <a :href="clientDetails.social_media.instagram" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-instagram" class="mr-3 account-icon"/>
                  </a>
                  <a :href="clientDetails.social_media.linkedIn" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-linkedin" class="mr-3 account-icon"/>
                  </a>
                  <a :href="clientDetails.social_media.quora" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-quora" class="mr-3 account-icon"/>
                  </a>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
      </div>
      <div class="vx-col w-full sm:w-full md:w-7/12 lg:w-2/3 xl:w-2/3 p-4">
        <div class="details_edit_holder">
          <vs-card class="cstm_vx_card" style="word-break: break-word;" v-if="!visible" title="Basic Details">
            <div class="flex flex-wrap justify-between items-center" slot="header">
              <h4>Details</h4>
              <div class="flex">
                <vs-tooltip color="primary" text="Edit" position="top">            
                <vs-button
                v-if="checkEditPermission()"
                  type="border"
                  icon="edit"
                  color="primary"
                  vs-type="flex"
                  @click="visible=!visible"
                />
                </vs-tooltip>
              </div>
            </div>      
            <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">First Name</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.first_name }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Last Name</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.last_name }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Phone Number</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.mobile }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Email</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.email }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Address Line 1</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.address.address1 }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Address Line 2</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.address.address2 }}
              </vs-col>

              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">City</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.address.city }}
              </vs-col>

              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">Postcode/Zip</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.address.zip }}
              </vs-col>

              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                <b style="font-weight: 600;">County/State</b>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2">
                {{ clientDetails.basic_details.address.state }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2" v-if="clientDetails.basic_details.address.timezone!=null">
                <b style="font-weight: 600;">Timezone</b>
              </vs-col>
               <vs-col vs-type="flex" vs-justify="left" vs-lg="3" vs-sm="6" vs-xs="12" vs-w="12" class="p-2" v-if="clientDetails.basic_details.address.timezone!=null">
                {{ clientDetails.basic_details.address.timezone.abbreviation }} {{ clientDetails.basic_details.address.timezone.offset }}
              </vs-col>
            </vs-row>
          </vs-card>
          <vx-card title="Edit Details" v-if="visible">
              <form data-vv-scope="add">
            <vs-row>
                    
               <vs-col :vs-xs="12" :vs-md="4" :vs-lg="4" class="p-2"  v-for="childfield in staticChildFields"
            :key="childfield.id">
             <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id' && childfield.is_address_field == 1 &&  childfield.field_name != 'platform_timezone_id'"
              v-model="clientDetails.basic_details.address[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
             
            />
             <vs-input
              v-else-if="childfield.field_name != 'platform_customer_countries_id' && childfield.is_address_field == 0"
              v-model="clientDetails.basic_details[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            
            />
            
                <v-select
                  v-else-if="childfield.field_name != 'platform_customer_countries_id' & childfield.is_address_field == 1 && childfield.field_name == 'platform_timezone_id'"
                  v-model="clientDetails.basic_details.address[childfield.field_name]"
                  v-validate="childfield.enabled_child == true ? 'required' : ''"
                  :reduce="(option) => option.timezone_id"
                  label="timezone"
                  :name="childfield.field_label"
                  :options="platformTimeZone"
                  style="width: 100%"
             
               icon-pack="feather"
              icon="icon-edit"
              icon-after
                />
            <v-select
              v-else
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="clientDetails.basic_details.address[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :placeholder="childfield.field_label"
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
              
            />
            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="childfield.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>

            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
             
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
              <vs-input v-validate="{url: {require_protocol: true }}" name="facebook" v-model="clientDetails.social_media.facebook" class="custom_Input" label="Facebook" style="width:100%;" />
              <span v-show="errors.has('add.facebook')" class="text-danger">{{ errors.first('add.facebook') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
              <vs-input v-validate="{url: {require_protocol: true }}" v-model="clientDetails.social_media.instagram" name="instagram" class="custom_Input" label="Instagram" style="width:100%;" />
              <span v-show="errors.has('add.instagram')" class="text-danger">{{ errors.first('add.instagram') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
              <vs-input v-validate="{url: {require_protocol: true }}" name="twitter" v-model="clientDetails.social_media.twitter" label="Twitter" style="width:100%;" />
              <span v-show="errors.has('add.twitter')" class="text-danger">{{ errors.first('add.twitter') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
              <vs-input v-validate="{url: {require_protocol: true }}" name="linkedin" v-model="clientDetails.social_media.linkedIn" class="custom_Input" label="Linkedin" style="width:100%;" />
              <span v-show="errors.has('add.linkedin')" class="text-danger">{{ errors.first('add.linkedin') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
              <vs-input v-validate="{url: {require_protocol: true }}" name="quara" v-model="clientDetails.social_media.quora" class="custom_Input" label="Quora" style="width:100%;" />
              <span v-show="errors.has('add.quara')" class="text-danger">{{ errors.first('add.quara') }}</span>
            </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
              <vs-button class="mr-2"  @click.prevent="updateDetail">Update</vs-button>
              <vs-button type="border" color="danger" @click="visible = false">Cancel</vs-button>
            </vs-row>
              </form>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { fetchCustomStaticFields } from '@/api/customfield'
import StatisticsCardLineNoChart from './cards.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { ClientDetails, updateClient } from '@/api/client'
import { GetCountryList } from '@/api/common'
import vSelect from 'vue-select'
import phone from '@/components/teachers/phone.vue'
import email from '@/components/teachers/email.vue'
import addressDetails from '@/components/teachers/address.vue'
import availabilityDetails from '@/components/teachers/availablity.vue'
import award from '@/components/teachers/award.vue'
import holiday from '@/views/pages/v1/user_profile/components/availability/holidays.vue'
import education from '@/components/teachers/educations.vue'
import language from '@/components/teachers/language.vue'
import socialLink from '@/components/clients/socialLinks'
import clientAddress from '@/components/clients/address'
import minors from '@/components/clients/minors'
import profileImage from '@/components/imageUpload/imageUploadAndShow'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'
export default {
  components: {
    StatisticsCardLineNoChart,
    flatPickr,
    vSelect,
    phone,
    email,
    addressDetails,
    availabilityDetails,
    award,
    holiday,
    education,
    language,
    socialLink,
    clientAddress,
    minors,
    profileImage
  },
  mixins: [GeneralMixins,PermissionMiddleware],
  data () {
    return {
      editPermissions:true,
      staticChildFields: [],
      cardTitle:'Other-Contacts',
      visible:false,
      clientDetails: {},
      basic_details: {},
      configdateTimePicker: {
        enableTime: false,
        enableSeconds: true,
        noCalendar: false
      },
      permissions:[],
      countryList:null,
      users:[],
      genderList: [
        {
          label:'Male',
          value:'MALE'
        },
        {
          label:'Female',
          value:'FEMALE'
        }
      ]
    }
  }, 
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Students')
    }
  },
  mounted () {
    const client_id = this.$route.params.client_user_id
    this.editPermissions = this.$route.params
    this.fetchclientsAccountDetails(client_id)
    this.fetchCountry()
    this.fetch_field_list()
    this.fetchPLatformTimeZone()
  },
  methods: {
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(4, customerId)
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {}
    },
    async ImageChanged (imageUrl) {
      // 
      try {
        const payload = {
          updateField:{
            picture: imageUrl,
            first_name: this.clientDetails.basic_details.first_name,
            middle_name: this.clientDetails.basic_details.middle_name,
            last_name:this.clientDetails.basic_details.last_name,
            email:this.clientDetails.basic_details.email,
            mobile: this.clientDetails.basic_details.mobile,
            address: this.clientDetails.basic_details.address,
            bio:this.clientDetails.bio,
            social_media:this.clientDetails.social_media
          }
        }
        const { data } = await updateClient(this.$route.params.client_user_id, payload,localStorage.getItem('customer_id'))
        this.clientDetails = data.data.clientUser
        this.visible = false
        this.$vs.notify({
          title: 'Updated',
          text: 'User Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        
      } catch (e) {
        
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    handleAccountEdit () {
      this.accountEdit = true
    },
    async fetchCountry () {
      try {
        const {data} = await GetCountryList()
        this.countryList = data.data.countries_list
        
      } catch (e) {
        
      }
    },
    async fetchclientsAccountDetails (teacher_id) {
      try {
        const { data } = await ClientDetails(teacher_id,this.$store.getters.customerId)
        this.clientDetails = data.data.clientUser
        
        const siblings = data.data.siblings
        let __temp = null
        for (const item of siblings) {
          const child = item.basic_details
          const address =  item.basic_details.address
          // 
          child.client_user_address =  item.basic_details.address
          child.client_user_address.client_users_id =  item.basic_details.client_users_id
          child.client_users_id =  item.basic_details.client_users_id
          __temp = {
            address,
            child
          }
          this.users.unshift(__temp)
        }
        const index = this.users.findIndex(temp => temp.child.client_user_address.client_users_id === Number(teacher_id))
        this.users.splice(index, 1)

        // if (this.clientDetails.address.length === 0) {
        //   this.clientDetails.address = [
        //     {
        //       address1: '',
        //       address2: '',
        //       city: '',
        //       id: '',
        //       state: '',
        //       zip: ''
        //     }
        //   ]
        // }
        // if (this.clientDetails.phone.length > 0) {
        //   const temm = this.clientDetails.phone
        //   temm.map(item => {
        //     if (item.default === '1') {
        //       item.default = 1
        //     } else {
        //       item.default = 0
        //     }
        //   })
        //   this.clientDetails.phone = temm
        // }
        // if (this.clientDetails.email.length > 0) {
        //   const temm_ = this.clientDetails.email
        //   temm_.map(item => {
        //     if (item.default === '1') {
        //       item.default = 1
        //     } else {
        //       item.default = 0
        //     }
        //   })
        //   this.clientDetails.email = temm_
        // }
        // if (this.clientDetails.availability.length === 0) {
        //   this.clientDetails.availability = [
        //     {
        //       day: null,
        //       available_from: null,
        //       available_to: null
        //     }
        //   ]
        // }
        // this.basic_details =  this.clientDetails.basic_details
        // this.permissions = this.clientDetails.basic_details.roleSubModules
      } catch (e) {
        
      }
    },
     updateDetail () {
      this.$validator.validateAll('add').then((valid) => {
        if (valid) {
          this.UpdateDetails()
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'All required fields are mandatory',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      })
    },
    async UpdateDetails () {
      try {
        const payload = {
          updateField:{
            first_name: this.clientDetails.basic_details.first_name,
            middle_name: this.clientDetails.basic_details.middle_name,
            last_name:this.clientDetails.basic_details.last_name,
            email:this.clientDetails.basic_details.email,
            mobile: this.clientDetails.basic_details.mobile,
            address: this.clientDetails.basic_details.address,
            bio:this.clientDetails.bio,
            social_media:this.clientDetails.social_media
          }
        }
        const { data } = await updateClient(this.$route.params.client_user_id, payload,localStorage.getItem('customer_id'))
        this.clientDetails = data.data.clientUser
        this.visible = false
        this.$vs.notify({
          title: 'Updated',
          text: 'User Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        
      } catch (e) {
        
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    havePermission (module) {
      const modules = this.permissions
      for (const item of modules) {
        if (item.sub_module_table === module) {
          if (item.enabled === 1) {
            return true
          } else {
            return false
          }
        }
      }
    },
    handleChangePage (id) {
      

    },
    getcountry (id) {
      const countryList = this.countryList
      for (const item of countryList) {
        if (item.id === id) {
          return item.country_name
        }
      }
    }
  }
}
</script>
<style scoped>
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
.custom_Input {
  border: none !important;
  border-bottom:1px solid rgba(0, 0, 0, 0.2);
}
.socialIcon{
  font-size:30px;
}
.required:after {
  content: " *";
  color: red;
}
@media only screen and (max-width: 1336px) {
  .profile_image {
    height:75px;
    width:75px;
    border-radius: 50%;
  }
}
</style>
